export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 rounded-t-[40px] mx-8 mb-8 shadow-2xl">
      <div className="max-w-7xl mx-auto px-20 py-24">
        {/* Upper Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-20">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img 
                src="https://public.readdy.ai/ai/img_res/d575b0a6-0900-4163-a903-160e73cf184e.png" 
                alt="STYLINE Logo" 
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-4xl font-light text-white">STYLINE</h3>
            </div>
            <p className="text-base text-white/60 mb-10">Your Privacy, Our Priority</p>
            <p className="text-sm text-white/60 leading-relaxed mb-12">
              STYLINE DOO POZAREVAC is dedicated to protecting your digital privacy with cutting-edge VPN technology. We provide secure, fast, and reliable connections to users worldwide.
            </p>

            <div className="flex items-center gap-5">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-white hover:text-cyan-400 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-white hover:text-cyan-400 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-2xl"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-white hover:text-cyan-400 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-white hover:text-cyan-400 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-[2px] mb-8">
              Quick Links
            </h4>
            <ul className="space-y-5">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-base text-white hover:text-cyan-400 transition-colors underline cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-base text-white hover:text-cyan-400 transition-colors underline cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-base text-white hover:text-cyan-400 transition-colors underline cursor-pointer"
                >
                  VPN Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('download')}
                  className="text-base text-white hover:text-cyan-400 transition-colors underline cursor-pointer"
                >
                  Download
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('support')}
                  className="text-base text-white hover:text-cyan-400 transition-colors underline cursor-pointer"
                >
                  Support
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-[2px] mb-8">
              Contact Us
            </h4>
            <div className="space-y-8">
              <div>
                <div className="text-xs text-white/60 mb-2">Phone</div>
                <a
                  href="tel:+14705168737"
                  className="text-lg text-white hover:text-cyan-400 transition-colors"
                >
                  +1 470 516 8737
                </a>
              </div>

              <div>
                <div className="text-xs text-white/60 mb-2">Email</div>
                <a
                  href="mailto:information@stylinedoopozarevac.com"
                  className="text-lg text-white hover:text-cyan-400 transition-colors break-all"
                >
                  information@stylinedoopozarevac.com
                </a>
              </div>

              <div>
                <div className="text-xs text-white/60 mb-2">Address</div>
                <div className="text-lg text-white leading-relaxed">
                  DJURE DJAKOVICA BB<br />
                  Pozarevac, 292510<br />
                  Serbia
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-sm text-white/60">
            © 2025 STYLINE DOO POZAREVAC. All rights reserved.
          </p>

          <div className="flex items-center gap-8">
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white hover:text-cyan-400 transition-colors underline"
            >
              Powered by Readdy
            </a>
            <a href="#" className="text-sm text-white hover:text-cyan-400 transition-colors underline">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-white hover:text-cyan-400 transition-colors underline">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
